import { combineReducers } from '@reduxjs/toolkit';

import { customPortalApi } from 'api/customPortalApi';

import loadingReducer, { setLoadingState, LoadingType } from './loading';

import accountReducer, { setPassword } from './account';

const rootReducer = combineReducers({
  loading: loadingReducer,
  account: accountReducer,
  [customPortalApi.reducerPath]: customPortalApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export { setLoadingState, setPassword, LoadingType };

export default rootReducer;
